import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import MuseumBonus from '@/roc/effects/CultureBonus/MuseumBonus';
import PassiveAura from "@/roc/effects/PassiveAura/PassiveAura";
import PassiveAuraType from "@/roc/effects/PassiveAura/PassiveAuraType";
import EffectAmount from "@/roc/effects/EffectAmount";

const CityHall = {
  id: "41",
  name: "City Hall",
  width: 5,
  height: 5,
  type: BuildingType.CITY_HALL,
  era: "stoneAge",
  icon: "Museum",
  workers: 2,
  minLevel: 1,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asFlat(12 * 60 * 60),
      ProductionOutput
        .asPerLevel([
          11000, // SE
          13400, // BE
          16300, // ME
          19800, // CG
          23500, // ER
          27400, // RE
          32000, // BYZ
          37000, // AOF
          42000, // FA
          48000, // IE
          55000, // KOS
          62000, // HMA
          75000, // EGE
          75000, // TODO: LGE
        ])
        .withOutput(ProductionOutputType.GOLD)
      ,
    ),
    new PassiveProduction(
      ProductionDuration.asFlat(8 * 60 * 60),
      ProductionOutput
        .asPerLevel([
          11000, // SE
          13400, // BE
          16300, // ME
          19800, // CG
          23500, // ER
          27400, // RE
          32000, // BYZ
          37000, // AOF
          42000, // FA
          48000, // IE
          55000, // KOS
          62000, // HMA
          75000, // EGE
          75000, // TODO: LGE
        ])
        .withOutput(ProductionOutputType.FOOD)
      ,
    ),
    new MuseumBonus(),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        2, // SE
        2, // BE
        2, // ME
        2, // CG
        2, // ER
        2, // RE
        2, // BYZ
        0, // AOF
        5, // FA
        0, // IE
        0, // KOS
        0, // HMA
        0, // EGE
        0, // LGE
      ]),
    ),
  ]),
};

export default CityHall;
